// Paleta de la dona de categorias (mismo orden que el diseno: azul, verde,
// ambar, morado, rojo...).
export const COLORES_CATEGORIA = ["#2563eb", "#22a35a", "#f5a524", "#a855f7", "#ef4444", "#06b6d4", "#64748b", "#ec4899"];

export const COLOR_VALOR_INVENTARIO = "#2563eb";

// Rotacion: los meses previos van en azul claro y el mes actual (ultima
// barra) resaltado en azul intenso.
export const COLOR_ROTACION_PREVIO = "#9cc0fb";
export const COLOR_ROTACION_ACTUAL = "#2563eb";
